import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  Button,
  Modal,
} from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { handleDigit, summary } from "../Utility/function";
import { MdRadioButtonUnchecked, MdRadioButtonChecked } from 'react-icons/md'; // replace with correct MaterialCommunityIcons mapping
import { colors, initialScb } from "../configs";
import Modal_Loading from "./Modal_Loading";
import { db, prepareFirebaseImage } from "../db/firestore";
import { useSelector } from "react-redux";
import { pushByIdFilter } from "../api/onesignal";
import firebase from 'firebase/app';
import { stringReceiptNumber } from "../Utility/dateTime";
import { FooterButton } from "../components";

const { white, dark, theme3 } = colors;

const initialObj = {
    shopId:'',
    shopName:'',
    profileId:'',
    profileName:'',
    timestamp:'',
    imageId:'',
    net:'',
    status:'order',//
    vat:false,
    email:'',
    tel:'',
};

const packageTypes= [
    { id:'1', type:'month', name:'รายเดือน'},
    { id:'2', type:'year', name:'รายปี'},
]

function Modal_Package({
  backdrop=true, // true/false/static
  animation=true,
  show,
  onHide,
  centered=true,
  display,
  admin,
  payment
}) {
  const { shop:{ shopId, name:shopName }} = useSelector(state=>state.shop);
  const { profile : { name:profileName, id:profileId, tel } } = useSelector((state) => state.profile);
  const [type, setType] = useState('month');
  const [current, setCurrent] = useState({ name:'', price:[] });
  const { name, price } = current;
  const [loading, setLoading] = useState(false);

  const [selected, setSelected] = useState([]);
  const [obj, setObj] = useState(initialObj);
  const { imageId, vat } = obj;
  
  const { netPrice, imagePayment } = useMemo(()=>{
      let sumPrice = summary(selected,'price')
      let imagePayment = payment.find(a=>a.value===sumPrice)?.imageId || initialScb
      return {
          netPrice:vat?1.07*sumPrice:sumPrice,
          imagePayment
      }
  },[selected,vat])

  useEffect(()=>{
    managePay(type)
  },[type])

    function managePay(type){
        if(type==='month'){
            const price = display.map(({ name, price, color })=>({ name, ...price.find(b=>b.save===0), color })).filter(b=>b.id)
            setCurrent({ name:'แพ็กเกจรายเดือน', price})
        } else {
            const price = display.map(({ name, price, color })=>({ name, ...price.find(b=>b.save!==0), color }))
            setCurrent({ name:'แพ็กเกจรายปี', price})
        }
        setSelected([]);

    }

    function manageSelected(item){
        if(selected.some(a=>a.id===item.id)){
            setSelected(selected.filter(a=>a.id!==item.id))
        } else {
            setSelected([...selected,item])
        }
    };

    const inputRef = useRef(null);
  
    const handleImageChange = (event) => {
      const file = event.target.files[0];
      if (!file) return;
  
      const reader = new FileReader();
      reader.onloadend = () => {
        setObj(prev=>({...prev,imageId:reader.result}))
      };
      reader.readAsDataURL(file);
    };
  
    const handleButtonClick = () => {
      inputRef.current.click(); // open file selector
    };

    function submit(){
        if(!Boolean(imageId)){
         
            alert('กรุณาแนบหลักฐาน การชำระเงิน')
        } else if(netPrice<1){
            alert('กรุณาเลือกแพ็กเกจใช้งานที่ต้องการ')
        } else {
            finalSubmit()
        }
    };


    async function finalSubmit(){
        setLoading(true)
        try {
            const imageUrl = await prepareFirebaseImage(imageId,'/packageOrder/',shopId);
            const packageRef = db.collection("admin").doc('packageNumber');
            const orderRef = db.collection("packageOrder").doc();
            const notiRef = db.collection('notification').doc();
            const newObj = {
                ...obj,
                shopId,
                shopName,
                profileId,
                profileName,
                timestamp:new Date(),
                imageId:imageUrl,
                tel,
                net:netPrice,
                packageId:selected.map(a=>a.id),
            }
            let orderNumber = stringReceiptNumber(1)
            await db.runTransaction(async (transaction)=>{
                const packageDoc = await transaction.get(packageRef);
                if(packageDoc.exists){
                    const { value } = packageDoc.data();
                    orderNumber = stringReceiptNumber(value+1)
                    transaction.update(packageRef, { value: value+1, timestamp:new Date()});
                }
                newObj.orderNumber = orderNumber
                transaction.set(orderRef,newObj)
                transaction.set(notiRef,{
                    heading:`สั่งซื้อแพ็กเกจสำเร็จ`, 
                    shopId, 
                    notificationContent:`แพ็กเกจ\n${selected.map(a=>`   ${a.name} (${handleDigit(a.price)} บาท)`).join(`\n`)}\nสถานะ : รอตรวจสอบ\n*รอตรวจสอบยืนยันการชำระเงิน ภายใน 24 ชั่วโมง`, 
                    categoryId:99,
                    timestamp:firebase.firestore.FieldValue.serverTimestamp() 
                })
            })
            pushByIdFilter({id:profileId,content:'รอตรวจสอบยืนยันการชำระเงิน ภายใน 24 ชั่วโมง',heading:'สั่งซื้อแพ็กเกจสำเร็จ',data : { sound:`สั่งซื้อแพ็กเกจสำเร็จค่ะ` }})
            for(const item of admin){
                pushByIdFilter({id:item,content:`ร้าน ${shopName}`,heading:`${shopName} ซื้อ${name} ${netPrice} บาท!`,data : { sound:`สั่งซื้อแพ็กเกจ ${netPrice} บาทค่ะ` }})
            }
        
            setLoading(false)
            onHide()
            alert('สั่งซื้อแพ็กเกจสำเร็จ\n*รอตรวจสอบยืนยันการชำระเงิน ภายใน 24 ชั่วโมง')
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

  return (
    <Modal
      backdrop={backdrop}
      animation={animation}
      show={show}
      onHide={onHide}
      centered={centered}
      fullscreen={true}
    >
      <Modal.Header closeButton>
        <h2><b>เติมแพ็กเกจ</b></h2>
      </Modal.Header>
        <Modal_Loading show={loading} />
      <Modal.Body  >
      <div style={{ padding: 16, border: '1px solid #ccc', borderRadius: 8 }}>
            <div style={{ marginBottom: 12, fontWeight: 'bold' }}>
                <h2>1. รูปแบบแพ็กเกจ</h2>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                {packageTypes.map((item) => {
                const { id, name, type:thisType } = item;
                const status = type === thisType

                return (
                    <div
                    key={id}
                    onClick={() => setType(thisType)}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        backgroundColor:white,
                        padding: 12,
                        borderRadius: 10,
                        cursor: 'pointer',
                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                        minWidth: 250,
                    }}
                    >
                    {status ? (
                        <MdRadioButtonChecked size={30} color={dark} />
                    ) : (
                        <MdRadioButtonUnchecked size={30} color={theme3} />
                    )}

                    <div>
                        <div style={{ fontSize: 18, fontWeight: 600 }}>{name}</div>
                    </div>
                    </div>
                );
                })}
            </div>
        </div>
        <br/><br/>
        <div style={{ padding: 16, border: '1px solid #ccc', borderRadius: 8 }}>
            <div style={{ marginBottom: 12, fontWeight: 'bold' }}>
                <h2>2. เลือกแพ็กเกจ(สูงสุด {price.length} แพ็กเกจ)</h2>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                {price.map((item) => {
                const { id, name, price: itemPrice, save, color } = item;
                const status = selected.some((a) => a.id === id);
                const backgroundColor = status ? color : white;

                return (
                    <div
                    key={id}
                    onClick={() => manageSelected(item)}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        backgroundColor,
                        padding: 12,
                        borderRadius: 10,
                        cursor: 'pointer',
                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                        minWidth: 250,
                    }}
                    >
                    {status ? (
                        <MdRadioButtonChecked size={30} color={dark} />
                    ) : (
                        <MdRadioButtonUnchecked size={30} color={theme3} />
                    )}

                    <div>
                        <div style={{ fontSize: 18, fontWeight: 600 }}>{name}</div>
                        <div>ราคา : {itemPrice}</div>
                        {save > 0 && (
                        <div style={{ fontSize: 12, color: '#888' }}>
                            [ประหยัด {save}]
                        </div>
                        )}
                    </div>
                    </div>
                );
                })}
            </div>
        </div>
        <br/>
        <div style={{ padding: 16, border: '1px solid #ccc', borderRadius: 8 }}>
            <div style={{ marginBottom: 12, fontWeight: 'bold' }}>
                <h2>3. ชำระเงิน</h2>
            </div>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center'}} >
                <img style={{ width:'300px'}} src={imagePayment} />
                <h4>ยอดชำระ : {handleDigit(netPrice)}</h4>
                <Button
                    variant="warning"
                    style={{
                    // width: '30%',
                    borderRadius: 20,
                    marginTop: 10,
                    paddingTop: 30,
                    paddingBottom: 30,
                    marginBottom: 10,
                    }}
                    onClick={handleButtonClick}
                >
                    <h3>4. แนบหลักฐานชำระเงิน</h3>
                </Button>

                {/* Hidden input */}
                <input
                    ref={inputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: 'none' }}
                />

                {/* Preview */}
                {imageId && (
                    <div style={{ marginTop: 20 }}>
                    <img
                        src={imageId}
                        alt="Preview"
                        style={{ maxWidth: '300px', maxHeight: '300px', borderRadius: 10 }}
                    />
                    </div>
                )}
            </div>
               
        </div>
      </Modal.Body>
      <FooterButton {...{ onHide, submit, rightText:'ยืนยัน' }} />
    </Modal>
  );
};

const styles = {
  container : {
      textAlign:'center', width: '9%', minWidth:'50px'
  },
  container2 : {
      textAlign:'center', width:'13%', textAlign:'center',minWidth:'150px'
  }
};

export default Modal_Package;
